//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[[0,"Preference",0,"Report.ReportPreference",0]],[[[],"CreateResultXmlFileWriter",{R_:{writer:"Report.ResultXmlFileWriter"}},0,0],[["imageFullFileName","width","height"],"GetOriginalImageDimension",{},1,0]],[["AutomationLogger","Report.AutomationLogger",0],["CommandManager","Report.CommandManager",0]]];
SPLM.Report.ReportManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Report.ReportManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;